import request from "../../../helpers/request"


export const getAlertasByUf = async (uf) => {
  const url = `${process.env.REACT_APP_API}/Loja/GetLojasByEstado?uf=${uf}`
  const result = await request({ url })
  return result.data
}